import React, { Component } from "react";
import NavBar from "../FrontPage/NavBar";
import { axiosPost } from "../../utils/AxiosApi";
import { URL } from "../../utils/Constants";
import "../../assets/scss/newGradeCss.scss";
import NewSubjectListDetail from "./NewSubjectListDetail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import defaultSubjectImage from "../../assets/images/defaultSubject.svg";
import GovHeader from "../GovHeader/GovHeader";
import FooterText from "../FrontPage/FooterText";

class NewGradePage extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    activeEduLevel: null,
    classes: [],
    courseList: [],
    educationLevel: [],
    grade: null,
    selectedSubject: null,
    subjectList: [],
    coursePlanSelected: false,
    readingMaterials: false,
    resources: null,
    fetching: false,
    gamesToggle: false,
    readingMaterials: false,
    mcqBox: false,
    flashCardBox: false,
    lmsToggled: false,
    memoryGameBox: false,
    fetchingSubjects: false,
  };

  componentDidMount() {
    this.getAllEducationList();
  }

  getAllEducationList = () => {
    axiosPost(URL.getAllEducationLevel, {}, (response) => {
      if (response.status === 200) {
        const educationLevels = response.data.data;
        let yearLevels = [];
        if (educationLevels[0] && educationLevels[0].yearLevels) {
          educationLevels.forEach((el) => {
            if (el.yearLevels.length > 0) {
              el.yearLevels.forEach((c) => {
                yearLevels.push(c);
              });
            }
          });
          this.setState(
            {
              grade: educationLevels[0].yearLevels[0],
              activeEduLevel: educationLevels[0].name,
              classes: yearLevels,
              subjectList: [],
              fetchingSubjects: true,
            },
            function () {
              this.getSubjectList();
            }
          );
        }
        this.setState({ educationLevel: response.data.data });
      }
    });
  };

  getSubjectList = () => {
    let datum = this.state.grade;
    let param = {
      yearLevelId: datum.id,
    };
    axiosPost(
      URL.selectDistinctSubjectsByYearLevelCore,
      param,
      (response) => {
        if (response.status === 200) {
          this.setState({
            subjectList: response.data.data,
            fetchingSubjects: false,
          });
        } else {
          this.setState({
            fetchingSubjects: false,
          });
        }
      },
      (err) => {
        this.setState({
          fetchingSubjects: false,
        });
      }
    );
  };

  goBack = () => {
    if (this.state.selectedSubject && this.state.coursePlanSelected) {
      this.setState({ coursePlanSelected: false });
    } else if (this.state.selectedSubject && this.state.lmsToggled) {
      this.setState({ lmsToggled: false });
    } else if (
      this.state.selectedSubject &&
      this.state.gamesToggle &&
      this.state.mcqBox
    ) {
      this.setState({ mcqBox: false });
    } else if (
      this.state.selectedSubject &&
      this.state.gamesToggle &&
      this.state.flashCardBox
    ) {
      this.setState({ flashCardBox: false });
    } else if (
      this.state.selectedSubject &&
      this.state.gamesToggle &&
      this.state.memoryGameBox
    ) {
      this.setState({ memoryGameBox: false });
    } else if (this.state.selectedSubject && this.state.gamesToggle) {
      this.setState({ gamesToggle: false });
    } else if (this.state.selectedSubject && this.state.readingMaterials) {
      this.setState({
        readingMaterials: false,
      });
    } else {
      this.setState({
        resources: null,
        selectedSubject: null,
        readingMaterials: false,
        gamesToggle: false,
        flashCardBox: false,
        mcqBox: false,
        memoryGameBox: false,
        coursePlanSelected: false,
      });
    }
  };

  selectGrade = (data) => {
    this.setState(
      {
        selectedSubject: null,
        resources: null,
        coursePlanSelected: false,
        readingMaterials: false,
        gamesToggle: false,
        flashCardBox: false,
        memoryGameBox: false,
        mcqBox: false,
      },
      function () {
        this.setState(
          { grade: data, subjectList: [], fetchingSubjects: true },
          function () {
            this.getSubjectList();
          }
        );
      }
    );
  };

  selectSubject = (data) => {
    this.setState({
      selectedSubject: data,
      resources: null,
      readingMaterials: false,
      gamesToggle: false,
      flashCardBox: false,
      mcqBox: false,
      coursePlanSelected: false,
      memoryGameBox: false,
    });
    // const param = {
    //   type: "student",
    //   classId: this.state.grade.id,
    //   subjectId: data.id,
    // };
    // axiosPost(URL.getAllCoursePlan, param, (response) => {
    //   if (response.status === 200) {
    //     this.setState({
    //       courseList: response.data.data,
    //       selectedSubject: data,
    //       coursePlanSelected: true,
    //     });
    //   }
    // });
  };

  setCourseList = () => {};

  toggleLMS = (type) => {
    let schoolLmsTypeId =
      type === "curriculum"
        ? 1
        : type === "textbooks"
        ? 2
        : type === "question-bank"
        ? 3
        : type === "av-resource"
        ? 4
        : type === "sign-language"
        ? 5
        : "";
    this.getLMSResources(schoolLmsTypeId);
  };

  getLMSResources = (schoolLmsTypeId) => {
    const param = {
      schoolLmsTypeId: schoolLmsTypeId,
      yearlevelId: this.state.grade.id,
      subjectId: this.state.selectedSubject.id,
    };
    this.setState({ fetching: true, lmsToggled: true }, () => {
      axiosPost(
        URL.getSchoolLMS,
        param,
        (response) => {
          if (response.status === 200) {
            this.setState({ fetching: false, resources: response.data.data });
          } else {
            this.setState({ fetching: false });
          }
        },
        (err) => {
          this.setState({ fetching: false });
        }
      );
    });
  };

  toggleFeatureSelect = () => {
    let param = {
      yearlevelId: this.state.grade.id,
      subjectId: this.state.selectedSubject.id,
    };
    axiosPost(URL.getCoursePlanCore, param, (response) => {
      if (response.status === 200) {
        let data = response.data.data;
        let cl = data.filter(
          (d) =>
            d.subjectId === this.state.selectedSubject.id &&
            d.classId === this.state.grade.id
        );

        this.setState({
          courseList: cl,
          coursePlanSelected: true,
        });
      }
    });
  };
  toggleGames = () => {
    this.setState({
      gamesToggle: true,
    });
  };

  toggleReadingMaterials = () => {
    this.setState({
      readingMaterials: true,
    });
  };

  toggleMCQ = () => {
    this.setState({ mcqBox: !this.state.mcqBox });
  };

  toggleFlashCards = () => {
    this.setState({ flashCardBox: !this.state.flashCardBox });
  };

  toggleMemoryGame = () => {
    this.setState({ memoryGameBox: !this.state.memoryGameBox });
  };

  getLoggedInStatus = () => {
    let token = localStorage.getItem("token");
    if (token) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    return (
      // <div className="newBg">
      <div>
        {this.props.eLibrary ? null : (
          <NavBar
            teacherPage={false}
            classPage={
              this.props.homePage || this.props.location?.state?.homePage
                ? false
                : true
            }
            // homePage={
            //   this.props.location?.state?.homePage || this.props.homePage
            // }
            homePage={this.props.homePage}
            pathName={this.props.location?.pathname}
            noHeader={localStorage.getItem("token") ? true : false}
          />
        )}
        {localStorage.getItem("token") ? <GovHeader /> : null}

        <section>
          <div className="main-image1">
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="main-heading py-2">
                    <div className="d-flex justify-content-center gradePageHead">
                      {/* <h2 className="heading-06">Classes:</h2> */}
                      {this.state.educationLevel.length > 0 ? (
                        <h2 className="heading-06" style={{ fontWeight: 550 }}>
                          &nbsp;
                          {this.state.educationLevel.map((edu, idx) => {
                            return (
                              <span key={idx}>
                                {edu.name}{" "}
                                {idx === this.state.educationLevel.length - 1
                                  ? ""
                                  : "| "}
                              </span>
                            );
                          })}
                        </h2>
                      ) : null}
                    </div>
                    {this.getLoggedInStatus() &&
                      this.state.educationLevel.length > 0 && (
                        <div className="searchWidget float-right mobileSearch">
                          <Link
                            to={{
                              pathname: "/search-imagine",
                              state: {
                                noNav: true,
                                teacherPage: false,
                                classPage: true,
                                homePage:
                                  this.props.location?.state?.homePage ||
                                  this.props.homePage,
                              },
                            }}
                            className="newWidgetLink"
                          >
                            <div className="tt-widget-holder-new">
                              <div className="tt-widget-icon">
                                <div>
                                  <FontAwesomeIcon
                                    icon={faSearch}
                                    className="tt-widget-fontAwesome-icon"
                                    style={{
                                      fontSize: "40px",
                                      color: "#4878ae",
                                    }}
                                  />
                                  {/* <div className="tt-widget-title">Search</div> */}
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="my-2">
          <div className="gradeClassList">
            {this.state.classes.length > 0
              ? this.state.classes.map((cls, idx) => {
                  return (
                    <div
                      key={idx}
                      className={
                        cls.name === this.state.grade.name
                          ? "activeGradeClass"
                          : ""
                      }
                      onClick={() => this.selectGrade(cls)}
                    >
                      <span>{cls.name.replace("Class ", "")}</span>
                    </div>
                  );
                })
              : null}
          </div>
        </section>
        <section className="my-2 mb-4">
          <hr></hr>
          {this.state.selectedSubject ? (
            <NewSubjectListDetail
              goBack={this.goBack}
              selectedSubject={this.state.selectedSubject}
              courseList={this.state.courseList}
              coursePlanSelected={this.state.coursePlanSelected}
              featureSelected={this.state.featureSelected}
              toggleCoursePlan={this.toggleCoursePlan}
              toggleFeatureSelect={this.toggleFeatureSelect}
              toggleReadingMaterials={this.toggleReadingMaterials}
              toggleLMS={this.toggleLMS}
              subjectList={this.state.subjectList}
              selectSubject={this.selectSubject}
              readingMaterials={this.state.readingMaterials}
              toggleGames={this.toggleGames}
              gamesToggle={this.state.gamesToggle}
              toggleMCQ={this.toggleMCQ}
              toggleFlashCards={this.toggleFlashCards}
              mcqBox={this.state.mcqBox}
              flashCardBox={this.state.flashCardBox}
              grade={this.state.grade}
              resources={this.state.resources}
              lmsToggled={this.state.lmsToggled}
              toggleMemoryGame={this.toggleMemoryGame}
              memoryGameBox={this.state.memoryGameBox}
            />
          ) : (
            <div className="subjectClassList">
              {!this.state.fetchingSubjects &&
              this.state.subjectList?.length > 0 ? (
                this.state.subjectList?.map((sub, idx) => {
                  return (
                    <div
                      key={idx}
                      className="subjectBoxDiv"
                      onClick={() => this.selectSubject(sub)}
                    >
                      {sub.thumbnailPath && sub.thumbnailPath !== "" ? (
                        <div className="gradeImgHolder">
                          <img
                            src={URL.imageSelectURL + sub.thumbnailPath}
                            onError={(e) =>
                              (e.target.src = defaultSubjectImage)
                            }
                          />
                        </div>
                      ) : null}
                      <span>{sub.name}</span>
                    </div>
                  );
                })
              ) : (
                <>
                  {this.state.fetchingSubjects ? (
                    <div className="text-center">loading...</div>
                  ) : (
                    <div className="text-center">No subjects.</div>
                  )}
                </>
              )}
            </div>
          )}
        </section>
        <FooterText />
      </div>
    );
  }
}

export default NewGradePage;
